import React from 'react';
import { Chip } from '@material-ui/core';
import { DOCUSIGN_ROLE_NAMES, getInternalField } from 'constants/docusignTemplates';

const cellStyle = { padding: '8px 12px', borderBottom: '1px solid #eee', textAlign: 'left', verticalAlign: 'top' };
const headerCellStyle = { ...cellStyle, color: '#666', fontWeight: 500, fontSize: '0.8125rem', borderBottom: '1px solid #e0e0e0' };

const DocusignRolesView = ({ roles = [] }) => {
    if (!roles.length) {
        return (
            <div style={{ color: '#999', textAlign: 'center', padding: '32px 0' }}>
                No roles have been mapped for this template yet.
            </div>
        );
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {roles.map((role, index) => {
                const knownRole = DOCUSIGN_ROLE_NAMES.find((option) => option.value === role.name);
                return (
                    <div
                        key={role.name || index}
                        style={{ border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden' }}
                    >
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '12px 16px',
                            backgroundColor: 'var(--bg-canvas)'
                        }}>
                            <span style={{ fontWeight: 500, color: '#333' }}>{role.name}</span>
                            {!knownRole && (
                                <Chip size="small" color="secondary" label="Unsupported role name" />
                            )}
                            <span style={{ color: '#666', fontSize: '0.875rem' }}>
                                DocuSign role: <strong>{role.roleOnDocusignTemplate || '—'}</strong>
                            </span>
                            {knownRole && (
                                <span style={{ color: '#999', fontSize: '0.8125rem', marginLeft: 'auto' }}>
                                    {knownRole.recipient}
                                </span>
                            )}
                        </div>
                        {(role.fields || []).length === 0 ? (
                            <div style={{ color: '#999', padding: '16px', fontSize: '0.875rem' }}>
                                No fields mapped for this role.
                            </div>
                        ) : (
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr>
                                            <th style={headerCellStyle}>Template field (tab label)</th>
                                            <th style={headerCellStyle}>Internal field</th>
                                            <th style={headerCellStyle}>Value sent</th>
                                            <th style={headerCellStyle}>Format</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {role.fields.map((field, fieldIndex) => {
                                            const internalField = getInternalField(field.internalName);
                                            return (
                                                <tr key={`${field.internalName}-${fieldIndex}`}>
                                                    <td style={cellStyle}>{field.templateName}</td>
                                                    <td style={cellStyle}>{field.internalName}</td>
                                                    <td style={{ ...cellStyle, color: '#666' }}>{internalField?.source || '—'}</td>
                                                    <td style={{ ...cellStyle, color: '#666' }}>{internalField?.format || '—'}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default DocusignRolesView;
